

import {typesTpOrderdet} from './svtypes/tporderdetTypes'

import {SV_SOJ_ORCMOCK_ADDRESS} from '../constants'

let initStore = {
    loading: false,
    error: false,
    my_data: [],
    loadingTPORDERDET:false,
    errorTPORDERDET:false,
    errob :{
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 500,
        "error": "Default Error",
        "message": "500 null",
        "path": "/kk/svaddressDetailPost"
    },
  
    my_data_flyreview:{
        "dbitns":{
            "productId": -1,
            "itineraries": []
        },
        "dbitns_o":{
            "productId": 117,
            "itineraries": [{
                "segments": []
            }]
        },
        "dbitns_old":{
            "productId": 117,
            "itineraries": [
                {
                    "segments": [
                        {
                            "segmentId": 101,
                            "duration": "PT6H46M",
                            "id": "6",
                            "numberOfStops": null,
                            "carrierCode": "AS",
                            "number": "41",
                            "departure": {
                                "iataCode": "JFK",
                                "terminal": "7",
                                "at": "2025-02-11T16:00:00"
                            },
                            "arrival": {
                                "iataCode": "SFO",
                                "terminal": "1",
                                "at": "2025-02-11T19:46:00"
                            },
                            "aircraft": {
                                "code": "2025-02-11T19:46:00"
                            },
                            "operating": null,
                            "co2Emissions": null
                        },
                        {
                            "segmentId": 102,
                            "duration": "PT5H41M",
                            "id": "9",
                            "numberOfStops": null,
                            "carrierCode": "AS",
                            "number": "35",
                            "departure": {
                                "iataCode": "SFO",
                                "terminal": "1",
                                "at": "2025-02-24T13:20:00"
                            },
                            "arrival": {
                                "iataCode": "JFK",
                                "terminal": "7",
                                "at": "2025-02-24T22:01:00"
                            },
                            "aircraft": {
                                "code": "2025-02-24T22:01:00"
                            },
                            "operating": null,
                            "co2Emissions": null
                        }
                    ],
                    "itnId": 48
                },
                {
                    "segments": [
                        {
                            "segmentId": 103,
                            "duration": "PT6H46M",
                            "id": "6",
                            "numberOfStops": null,
                            "carrierCode": "AS",
                            "number": "41",
                            "departure": {
                                "iataCode": "JFK",
                                "terminal": "7",
                                "at": "2025-02-11T16:00:00"
                            },
                            "arrival": {
                                "iataCode": "SFO",
                                "terminal": "1",
                                "at": "2025-02-11T19:46:00"
                            },
                            "aircraft": {
                                "code": "2025-02-11T19:46:00"
                            },
                            "operating": null,
                            "co2Emissions": null
                        },
                        {
                            "segmentId": 104,
                            "duration": "PT5H41M",
                            "id": "9",
                            "numberOfStops": null,
                            "carrierCode": "AS",
                            "number": "35",
                            "departure": {
                                "iataCode": "SFO",
                                "terminal": "1",
                                "at": "2025-02-24T13:20:00"
                            },
                            "arrival": {
                                "iataCode": "JFK",
                                "terminal": "7",
                                "at": "2025-02-24T22:01:00"
                            },
                            "aircraft": {
                                "code": "2025-02-24T22:01:00"
                            },
                            "operating": null,
                            "co2Emissions": null
                        }
                    ],
                    "itnId": 49
                }
            ]
        },
        "Request": {
            "checkin": "OK",
            "stay": "6",
            "stayInit": "nights",
            "checkout": "UU12345",
            "checkinTime": "Sat, Sept 9, 3027",
            "checkinTimePrefix": "From 3:00 PM",
            "checkoutTimePrefix": "Until 11:00 AM",
            "checkoutTime": "Sat, Sept 16, 3027"
        },
        "spaceDet": {
        
            "space_details": "Queen Room with Two Queen Beds",
            "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
            "cancellation": "Free cancellation before December 9, 2024 ",
            "guests": "2 adults ",
            "cleaniness_score" : "7.7",
            "non_smoking":true,
    
            "space_amenity_name": [
                "300 feet elevator",
                "air conditioning",
                "private bathroom"
            ]
           
           
        },
        "booking": {
            "airport_id": 30009,
            "origin_airport_code": 1,
            "origincity": "homer",
            "origin_airport_city": "homer",
            "origin_airport_country": "usa",
            "origin_airport_timezone": "america/new_york",
            "port_code_iata": 30009,
            "airlines_db_id": 146,
            "origin_airport_iata": "09a",
            "dst_airport_code": "adq",
            "airlines_vessel": "cr9",
            "airlines_name_iata": "2o",
            "airlines_code_iata": 4,
            "flight_space_id": 13,
            "flight_departure": "10:30",
            "flight_departure_time": "10:30",
            "flight_arrival": "04:30",
            "flight_arrival_time": "04:30",
            "flight_airline_num_stops": 1,
            "flight_arrival_daytime": "pm",
            "flight_departure_daytime": "am",
            "startdate": "2023-11-24",
            "enddate": "2026-12-01",
            "airlines_name": "air salone",
            "org_aiport_csc_addr": "homer,alaska,usa",
            "flight_time_hhmm": "6hr 29min",
            "flight_time": 209,
            "flight_operated_by": "4009 operated by envoy airlines",
            "flight_operator_owned": "y",
            "origin_airport_state": "alaska",
            "flight_departure_time_tzest": "2025-10-25t10:30:00-0400",
            "flight_departure_date": "2025-10-25",
            "flight_arrival_date": "2025-10-26",
            "flight_arrival_time_tzest": "2025-10-26t16:30:00-0400",
            "flight_space_key": "1@4@1@adq"
        },
        "price": {
            "total": "$923",
            "depositValue":"$200.26",
            "depositName":"Damage Deposit (Fully refundable)",
            "currency": "usd",
            "tax": {
               
                "taxTotal": "$102.34",
                "maintax": "$49.08",
                "citytax": "$53.26",
    
                "taxPercent": "6",
                "citytaxPercent": "6.5"
            }
        },
        "id": "addLeft_step",
        "gene": "addLeft_step",
        "dcountry": "China",
        "privateparking":false,
        "rentcar":false,
        "bookTaxi":false,
        "needFlight":false,
        "arrivalTimeZone":"tz_pst",
        "fname": "John",
        "lname": "Glen",
        "email": "john123@yahoo.com",
        "address": "Glen",
        "city": "Glen",
        "state": "Glen",
        "zip": "12110",
        "country": "Glen",
        "isdcode": "+1",
        "phone": "Glen",
        "bookingAgentType": "self",
        "traveType": "Personal",
        "specialRequests": "Wheel chair and Senior Citizen",
        "gname": "Glen",
        "gemail": "Glen@yahoo.com",
        "card": "1234-1234--1234--1234",
        "cvv": "Glen",
        "mmexp": "04",
        "yyyyexp": "2028"
    }
   
    
   
    
}

export default (state = initStore, action) => {
    console.log(action);
    let januState;
    switch (action.type) {
        
        
        case 'GET_TPORDERDET_SUCCESS':
            console.log("reduce %%%%%%%%GET_TPORDERDET_SUCCESS  success*****************");
            console.log(action.payload.my_data_flyreview);
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
            januState = {...state, loadingTPORDERDET: false, my_data_flyreview: action.payload.my_data_flyreview}
            return januState
        case 'GET_TPORDERDET_BEGIN':
                console.log("loading")
                return {...state, loadingTPORDERDET: true}
        case 'GET_TPORDERDET_ERROR':
            console.log("error")
            console.log(action.payload.errob)
            const errjson = {
                "timestamp": "2024-08-23T02:27:18.038+0000",
                "status": 500,
                "error": "Internal Server Error",
                "message": "500 null",
                "path": "/accountclient/svaddressDetailPost"
            }
            return {...state,errob:action.payload.errob, errorTPORDERDET: true}
     
               
        
        
        default:
            return state
    }
}